/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Scope_Item_3Inputs */

const es_privacy_policy_scope_item_3 = /** @type {(inputs: Privacy_Policy_Scope_Item_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuestra API y cualquier integracion con servicios externos`)
};

const en_privacy_policy_scope_item_3 = /** @type {(inputs: Privacy_Policy_Scope_Item_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our API and any integration with external services`)
};

/**
* | output |
* | --- |
* | "Our API and any integration with external services" |
*
* @param {Privacy_Policy_Scope_Item_3Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_scope_item_3 = /** @type {((inputs?: Privacy_Policy_Scope_Item_3Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Scope_Item_3Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_scope_item_3(inputs)
	return en_privacy_policy_scope_item_3(inputs)
});
export { privacy_policy_scope_item_3 as "privacy_policy.scope.item_3" }